module.exports = __webpack_public_path__ + "img/20230802101044353jgp.de29ff77.png";